module.exports = __webpack_public_path__ + "img/list.6cc10bcf.png";